import { useHotkeys } from 'react-hotkeys-hook';

export interface KeyboardShortcut {
  key: string;
  description: string;
  action: () => void;
  enabled?: boolean;
}

export function useKeyboardShortcuts(shortcuts: KeyboardShortcut[]) {
  shortcuts.forEach(({ key, action, enabled = true }) => {
    useHotkeys(key, (e) => {
      e.preventDefault();
      action();
    }, { enabled, enableOnFormTags: false }, [action, enabled]);
  });
  
  return shortcuts;
}
